import React from 'react';
import styles from './modal-note.scss';
import classnames from 'classnames';

const ModalNote = ({children}) => {
  return (
    <div className={styles.container}>
      <div className={classnames('svg-ico-lightbulb', styles.icon)} />
      {children}
    </div>
  );
};

export default ModalNote;

ModalNote.propTypes = {children: React.PropTypes.any};



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/modal-note.jsx